import React from 'react'
import useAuth from '../hooks/useAuth';
import { Box,  Modal, styled } from '@mui/material';

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 610,
    bgcolor: "background.paper",
    border: "1px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const Image = styled('img')({
    // height: '41px',
    objectFit: 'contain',
    // resizeMode: 'contain',
    // alignSelf: 'center',
  });

const ImageModal = ({open, setOpen, source}) => {
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const { handleSignOut, isAuthLoading } = useAuth()
  
    return (
      <div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
            <Box sx={{...style, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            {/* <Typography id="modal-modal-title" variant="h6" component="h2" color="textPrimary" fontWeight={'bold'} align='center' >
              Titulo
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }} color="textPrimary" align='center'>
              ¿Estás seguro que quieres cerrar sesión?
            </Typography> */}
                <Image src={source} alt="Modal content" width={550} height={450} />
            </Box>
        </Modal>
      </div>
    );
}

export default ImageModal
